import type { ComponentChildren } from "preact";
import * as stylex from "@stylexjs/stylex";

const styles = stylex.create({
    container: {
        position: "relative",
        margin: "auto",
        width: "600px",
        height: "600px",
        overflow: "auto",
    },
});

export default function AppContainer({ children }: { children: ComponentChildren }) {
    return <div {...stylex.props(styles.container)}>{children}</div>;
}
